const field = document.querySelector('[data-model-prop]');
const context = document.querySelector('#ssd-machine-finder');
if (field && context?.dataset.inlineOnly === 'true') {
  const copy = JSON.parse(document.querySelector('#ssd-mf-copy').textContent);
  const normalize = value => value.toUpperCase().replace(/[^A-Z0-9]/g, '');
  let choices = [], state = 'loading', active = -1, visible = [], composing = false;
  const list = document.createElement('div');
  list.id = 'ssd-model-suggestions'; list.className = 'ssd-model-suggestions';
  list.setAttribute('role', 'listbox'); list.setAttribute('aria-label', copy.models); list.hidden = true;
  (field.closest('label') || field).after(list);
  const feedback = document.createElement('div');
  feedback.id = 'ssd-model-feedback'; feedback.className = 'ssd-model-feedback';
  feedback.setAttribute('role', 'status'); feedback.setAttribute('aria-live', 'polite');
  feedback.setAttribute('aria-atomic', 'true'); feedback.hidden = true; list.after(feedback);
  const describedBy = field.getAttribute('aria-describedby');
  function showFeedback(message = '', selected = false) {
    feedback.textContent = message; feedback.hidden = !message;
    feedback.classList.toggle('is-selected', selected);
    if (message) field.setAttribute('aria-describedby', [describedBy, feedback.id].filter(Boolean).join(' '));
    else if (describedBy) field.setAttribute('aria-describedby', describedBy);
    else field.removeAttribute('aria-describedby');
  }
  field.setAttribute('role', 'combobox'); field.setAttribute('aria-autocomplete', 'list');
  field.setAttribute('aria-controls', list.id); field.setAttribute('aria-expanded', 'false');
  function key(value, make) {
    let result = normalize(value);
    for (const prefix of make === 'CAT' ? ['Caterpillar', 'CAT'] : make === 'John Deere' ? ['John Deere', 'Deere'] : [make]) {
      const brand = normalize(prefix); if (brand && result.startsWith(brand)) return result.slice(brand.length);
    }
    return result;
  }
  function matches(row, value, exact = false) {
    const query = key(value, row.make);
    return row.keys.some(k => exact ? k === query : k.startsWith(query));
  }
  function close() { list.hidden = true; active = -1; field.setAttribute('aria-expanded', 'false'); field.removeAttribute('aria-activedescendant'); }
  function select(row) { field.value = row.model; close(); field.dispatchEvent(new Event('input', { bubbles: true })); field.dispatchEvent(new Event('change', { bubbles: true })); close(); showFeedback('Model selected: ' + row.model, true); }
  function highlight(index) {
    active = index;
    [...list.children].forEach((option, i) => option.setAttribute('aria-selected', String(i === active)));
    if (active >= 0) { field.setAttribute('aria-activedescendant', list.children[active].id); list.children[active].scrollIntoView({ block: 'nearest' }); }
  }
  function render() {
    list.replaceChildren(); active = -1; field.removeAttribute('aria-activedescendant');
    visible = choices.filter(c => matches(c, field.value.trim()));
    if (state !== 'ready' || !visible.length || document.activeElement !== field) { close(); return; }
    for (const [index, row] of visible.entries()) {
      const option = document.createElement('button'); option.type = 'button'; option.tabIndex = -1;
      option.id = 'ssd-model-option-' + index; option.setAttribute('role', 'option'); option.setAttribute('aria-selected', 'false');
      option.textContent = row.model; option.addEventListener('pointerdown', event => event.preventDefault());
      option.addEventListener('click', () => { select(row); field.focus(); close(); }); list.append(option);
    }
    list.hidden = false; field.setAttribute('aria-expanded', 'true');
  }
  field.addEventListener('focus', render);
  field.addEventListener('input', event => { showFeedback(); if (event.isComposing || composing) return; render(); });
  field.addEventListener('compositionstart', () => { composing = true; close(); showFeedback(); });
  field.addEventListener('compositionend', () => { composing = false; render(); });
  function confirmEntry() {
    close();
    const value = field.value.trim();
    if (!value || state !== 'ready' || !choices.length || composing) { showFeedback(); return; }
    const exact = choices.filter(row => matches(row, value, true));
    if (exact.length === 1) {
      select(exact[0]);
    } else {
      showFeedback("Model not in these suggestions? You can leave this blank and continue. We'll confirm the details after ordering.");
    }
  }
  field.addEventListener('blur', confirmEntry);
  field.form?.addEventListener('reset', () => { close(); showFeedback(); });
  field.addEventListener('keydown', event => {
    if (event.isComposing || composing) return;
    if (event.key === 'Escape') { close(); return; }
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault(); if (list.hidden) render(); if (!visible.length || list.hidden) return;
      highlight(active < 0 ? (event.key === 'ArrowDown' ? 0 : visible.length - 1) : (active + (event.key === 'ArrowDown' ? 1 : -1) + visible.length) % visible.length);
    } else if (event.key === 'Enter') {
      // Confirm the model, never implicitly submit the product form or select a blank suggestion.
      event.preventDefault();
      const value = field.value.trim(), exact = choices.filter(row => matches(row, value, true));
      if (value && !list.hidden && visible.length) {
        select(active >= 0 ? visible[active] : exact.length === 1 ? exact[0] : visible[0]);
      } else confirmEntry();
    }
  });
  const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 10000);
  try {
    const response = await fetch(context.dataset.fitmentUrl, { signal: controller.signal });
    if (!response.ok) throw Error('Model data unavailable');
    const data = await response.json(), mapped = new Map();
    const handle = context.dataset.productHandle;
    const groups = [...(data.families || []), ...(data.productListings || [])].filter(group => group.handle === handle && !/1-4-inch|quarter/.test(group.handle));
    for (const group of groups) for (const model of group.models) {
      const identity = key(model, group.make), existing = mapped.get(identity);
      const keys = new Set(existing?.keys || [identity]);
      if (group.shortPrefix && identity.startsWith(normalize(group.shortPrefix))) keys.add(identity.slice(normalize(group.shortPrefix).length));
      if (group.shortSuffix && identity.endsWith(normalize(group.shortSuffix))) keys.add(identity.slice(0, -normalize(group.shortSuffix).length));
      mapped.set(identity, { model, make: group.make, detail: existing?.detail || group.detail || '', keys: [...keys] });
    }
    choices = [...mapped.values()].sort((a,b) => a.model.localeCompare(b.model, 'en', { numeric: true }));
    state = 'ready'; render();
  } catch { state = 'error'; close(); } finally { clearTimeout(timer); }
}
